/** User / mahasiswa / dosen-role live queries. */

import { COL } from '../../collections';
import { where, orderBy } from '../../collections';
import { useLiveQuery } from '../hooks';
import type { DosenRoleDoc, MahasiswaDoc, UserDoc } from '../../types';

export function useAllUsers() {
  return useLiveQuery<UserDoc>(COL.users, [orderBy('name', 'asc')]);
}

export function useAllMahasiswa() {
  return useLiveQuery<MahasiswaDoc>(COL.mahasiswa, [orderBy('name', 'asc')]).data;
}

export function useDosenUsers() {
  return useLiveQuery<UserDoc>(COL.users, [where('role', '==', 'dosen'), orderBy('name', 'asc')]);
}

export function useDosenRolesFor(dosenId: string | null) {
  return useLiveQuery<DosenRoleDoc>(
    dosenId ? COL.dosenRoles : null,
    dosenId ? [where('dosenId', '==', dosenId), orderBy('assignedAt', 'desc')] : [],
    Boolean(dosenId),
  );
}
